import { CreateAlert, onError } from 'modules';
import React from 'react';

import { InputCheckbox } from '../../../components';
import { ConfigService } from '../../../services/config/config.service';
import { useSelector } from '../../../store';
import { store } from '../../../store';
import { withConfigWraper } from '../wraper';

export const MaintenanceConfig = withConfigWraper(() => {
  const maintenanceConfig = useSelector((state) => state.maintenanceConfig);

  const checkConfig = () => {
    if (maintenanceConfig) {
      const body = {
        enable: false,
      };
      return ConfigService.swithMaintenanceServer(body)
        .then(async () => {
          CreateAlert({
            type: 'success',
            message: 'Set config maintenance successful.',
          });
          await ConfigService.getServerConfigMaintenance(store);
        })
        .catch(onError);
    } else {
      const body = {
        enable: true,
      };
      return ConfigService.swithMaintenanceServer(body)
        .then(async () => {
          CreateAlert({
            type: 'success',
            message: 'Set config maintenance successful.',
          });
          await ConfigService.getServerConfigMaintenance(store);
        })
        .catch(onError);
    }
  };

  return (
    <div className='row mb20'>
      <div className='col-sm-5'>
        <form className=''>
          <InputCheckbox
            type={'checkbox'}
            label={'Maintenance Server'}
            value={maintenanceConfig}
            onChange={checkConfig}
            name=''
            onTouched={checkConfig}
          />
        </form>
      </div>
    </div>
  );
});
